import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {SelectableUserModel} from "../types/selectable-user.model";
import {toBoolean, toList} from "../helpers/helpers";
import {map} from "rxjs/operators";

@Injectable()
export class UserSelectionService {
  constructor(private http: HttpClient) {}

  getUsersForProject(projectId: string): Promise<SelectableUserModel[]> {
    return this.http.get<{users: SelectableUserModel[]}>("/api/project-user/", {params: {projectId}})
      .pipe(map(json => toList(SelectableUserModel.converter, json.users)))
      .toPromise();
  }

  saveUsersForProject(projectId: string, userIds: string[]): Promise<boolean> {
    return this.http.post<{success: boolean}>("/api/project-user/", {userIds}, {params: {projectId}})
      .pipe(map(json => toBoolean(json.success)))
      .toPromise();
  }
}
